import { VideoVintageIcon } from './VideoVintageIcon';

/**
 * author: Mike G Chambers
 * id 1A8E4CC1-97A7-4593-BE20-0E9C5686C2D3
 * name video-vintage
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-vintage.svg
 * tags
 * - Video / Movie 
 */
export const VideoFilmIcon = VideoVintageIcon;
export default VideoFilmIcon